import Api from './axios';
import { createCounterTopUrl } from '../utils/createCounterTopUrl';

const log = (message, level = '') => {
  let path = 'countertops/api/log';
  if (level) {
    path = `${path}/${level}`;
  }

  return Api().post(createCounterTopUrl(path), `=${message}`);
};

export default log;
